import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const applicationRetryReq = (applicationId: string, tokens: any, isAudit: boolean, filterType?: string) => {
  const request: JFSRequest<{}> = {
    apiPath: isAudit
      ? APIEndPoints.fiuRetry
      : filterType === 'AADHAR_REDACTION'
      ? APIEndPoints.aadharRedactionRetry
      : APIEndPoints.applicationRetry,
    method: 'POST',
    cache: false,
    body: { applicationId: applicationId, ...(filterType && filterType?.length > 0 ? { filterType: filterType } : {}) },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { applicationRetryReq }
